import type React from "react";
import { useState } from "react";

import { Icon } from "@material-ui/core";
import { EmojiObjects, KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import styled from "styled-components";

import { Body, BodySmallBold } from "./styles";

interface Props {
  tip_description: string;
  tip_title: string;
}

export const TipCard: React.FC<Props> = ({ tip_description, tip_title }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Container onClick={() => setIsExpanded(prevState => !prevState)}>
      <TipHeading>
        <TipTitleContainer>
          <EmojiObjects style={{ fontSize: "24px", marginRight: "8px", color: "rgb(232, 137, 80)" }} />
          <BodySmallBold>{tip_title}</BodySmallBold>
        </TipTitleContainer>
        <TipArrow>
          <Icon style={{ fontSize: "16px" }}>{isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</Icon>
        </TipArrow>
      </TipHeading>
      {isExpanded && tip_description && <StyledBody>{tip_description}</StyledBody>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  padding: 12px 16px;
  background-color: #fffdfc;
  border-radius: 8px;
`;

const TipHeading = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TipTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TipArrow = styled.div`
  display: flex;
`;

const StyledBody = styled(Body)`
  margin: 8px 4px 4px;
  color: ${({ theme }) => theme.colors.redesign.db70};
  white-space: pre-wrap;
`;
